module.exports = __webpack_public_path__ + "img/chara1.d4417c83.png";